import React from "react";
import Inventory from "./Inventory";
import "../Styles/phoneInventory.css";

function PhoneAssetStats() {
  return (
    <div className="phone-inventory">
      <div className="phone-inventory-title">INVENTORY</div>
      <div className="phone-inventory-item">
        <div className="inventory-item-icon"></div>
        <div className="inventory-item-name"></div>
      </div>
      <div className="phone-inventory-item">
        <div className="inventory-item-icon"></div>
        <div className="inventory-item-name"></div>
      </div>
      <div className="phone-inventory-item">
        <div className="inventory-item-icon"></div>
        <div className="inventory-item-name"></div>
      </div>
      <div className="phone-inventory-item">
        <div className="inventory-item-icon"></div>
        <div className="inventory-item-name"></div>
      </div>
    </div>
  );
}

export default PhoneAssetStats;
